module.exports = __webpack_public_path__ + "static/media/measurement-first.d55c5d11.svg";